export const DataArray = [
    {
        "id":1,
        "name":"HTML5",
        "src":"html5.svg",
        "proficiency": 98,
        "category": "Frontend",
        "experience": "5+ years"
    },
    {
        "id":2,
        "name":"CSS3",
        "src":"css.svg",
        "proficiency": 98,
        "category": "Frontend",
        "experience": "5+ years"
    },
    {
        "id":3,
        "name":"JavaScript",
        "src":"js.png",
        "proficiency": 95,
        "category": "Frontend",
        "experience": "5+ years"
    },
    {
        "id":4,
        "name":"TypeScript",
        "src":"typescript.png",
        "proficiency": 95,
        "category": "Frontend",
        "experience": "4+ years"
    },
    {
        "id":5,
        "name":"React",
        "src":"react.png",
        "proficiency": 98,
        "category": "Frontend",
        "experience": "8+ years"
    },
    {
        "id":6,
        "name":"React Hooks",
        "src":"react.png",
        "proficiency": 98,
        "category": "Frontend",
        "experience": "4+ years"
    },
    {
        "id":7,
        "name":"Next.js",
        "src":"nextjs.png",
        "proficiency": 92,
        "category": "Frontend",
        "experience": "3+ years"
    },
    {
        "id":8,
        "name":"Vue.js",
        "src":"vue.png",
        "proficiency": 88,
        "category": "Frontend",
        "experience": "3+ years"
    },
    {
        "id":9,
        "name":"SASS/SCSS",
        "src":"sass.png",
        "proficiency": 95,
        "category": "Frontend",
        "experience": "5+ years"
    },
    {
        "id":10,
        "name":"Tailwind CSS",
        "src":"css.svg",
        "proficiency": 92,
        "category": "Frontend",
        "experience": "3+ years"
    },
    {
        "id":11,
        "name":"Ant Design",
        "src":"ant-design.svg",
        "proficiency": 90,
        "category": "Frontend",
        "experience": "3+ years"
    },
    {
        "id":12,
        "name":"Shadcn/ui",
        "src":"shadcn.png",
        "proficiency": 88,
        "category": "Frontend",
        "experience": "1+ years"
    },
    {
        "id":13,
        "name":"Zustand",
        "src":"redux.png",
        "proficiency": 90,
        "category": "Frontend",
        "experience": "2+ years"
    },
    {
        "id":14,
        "name":"React Flow",
        "src":"reactflow.png",
        "proficiency": 88,
        "category": "Frontend",
        "experience": "2+ years"
    },
    {
        "id":15,
        "name":"Responsive Design",
        "src":"html5.svg",
        "proficiency": 98,
        "category": "Frontend",
        "experience": "5+ years"
    },
    {
        "id":16,
        "name":"Performance Optimization",
        "src":"react.png",
        "proficiency": 92,
        "category": "Frontend",
        "experience": "5+ years"
    },
    {
        "id":17,
        "name":"Accessibility (A11y)",
        "src":"html5.svg",
        "proficiency": 88,
        "category": "Frontend",
        "experience": "4+ years"
    },
    {
        "id":18,
        "name":"PWA",
        "src":"html5.svg",
        "proficiency": 88,
        "category": "Frontend",
        "experience": "3+ years"
    },
    {
        "id":19,
        "name":"Micro-frontends",
        "src":"react.png",
        "proficiency": 82,
        "category": "Frontend",
        "experience": "2+ years"
    },
    {
        "id":20,
        "name":"Git & GitHub",
        "src":"github.svg",
        "proficiency": 95,
        "category": "Tools",
        "experience": "5+ years"
    },
    {
        "id":21,
        "name":"NX Monorepo",
        "src":"nx.png",
        "proficiency": 85,
        "category": "Tools",
        "experience": "2+ years"
    },
    {
        "id":22,
        "name":"Vite",
        "src":"vite.jpeg",
        "proficiency": 88,
        "category": "Tools",
        "experience": "2+ years"
    },
    {
        "id":23,
        "name":"Chrome Extension",
        "src":"html5.svg",
        "proficiency": 92,
        "category": "Tools",
        "experience": "2+ years"
    },
    {
        "id":24,
        "name":"Jest",
        "src":"jest.png",
        "proficiency": 92,
        "category": "Tools",
        "experience": "4+ years"
    },
    {
        "id":25,
        "name":"React Testing Library",
        "src":"react.png",
        "proficiency": 90,
        "category": "Tools",
        "experience": "3+ years"
    },
    {
        "id":26,
        "name":"LaunchDarkly",
        "src":"ld.png",
        "proficiency": 85,
        "category": "Tools",
        "experience": "2+ years"
    },
    {
        "id":27,
        "name":"CI/CD",
        "src":"heroku.svg",
        "proficiency": 88,
        "category": "Tools",
        "experience": "4+ years"
    },
    {
        "id":28,
        "name":"Zendesk Copilot",
        "src":"zendesk.png",
        "proficiency": 88,
        "category": "Tools",
        "experience": "1+ years"
    },
    {
        "id":29,
        "name":"Org Chart Builder",
        "src":"react.png",
        "proficiency": 85,
        "category": "Tools",
        "experience": "2+ years"
    },
    {
        "id":30,
        "name":"React Native",
        "src":"react.png",
        "proficiency": 92,
        "category": "Mobile",
        "experience": "3+ years"
    },
    {
        "id":31,
        "name":"Expo",
        "src":"react.png",
        "proficiency": 90,
        "category": "Mobile",
        "experience": "3+ years"
    }
]
